var React = require('react');

function Outlier (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"outlier","stroke":"#C0771A","strokeWidth":"2"},React.createElement("g",{"id":"Group-6","transform":"translate(4.000000, 4.000000)"},[React.createElement("path",{"d":"M32,16 L32,16 C32,24.836556 24.836556,32 16,32 L16,32 C7.163444,32 1.082166e-15,24.836556 0,16 L0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 L16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 Z","id":"Rectangle-314","fill":"#FFBC67","key":0}),React.createElement("path",{"d":"M16,7 L16,19","id":"Path-2","key":1}),React.createElement("path",{"d":"M16,24 L16.1,24","id":"Path-2","key":2})]))));
}

Outlier.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40"};

module.exports = Outlier;

Outlier.default = Outlier;
